import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const day = (iso) => new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", timeZone: "Europe/London" });

export const ResultsReadyButton = ({ row }) => {
  const [open, setOpen] = useState(false);
  const [nameTests, setNameTests] = useState(false);
  const [busy, setBusy] = useState(false);
  const [sentAt, setSentAt] = useState(row.results_ready_at);
  const tests = row.tests || [];
  const send = () => {
    setBusy(true);
    api.post(`/admin/bookings/${encodeURIComponent(row.id)}/results-ready`, { name_tests: nameTests && tests.length > 0 })
      .then(({ data }) => { setSentAt(data.results_ready_at); setOpen(false); toast.success("Results email sent."); })
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message)).finally(() => setBusy(false));
  };
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={`results-ready-${row.id}`}
        className="block ml-auto text-sm text-bronze-dark hover:text-bronze underline underline-offset-4 whitespace-nowrap">
        {sentAt ? `Results email sent ${day(sentAt)} · resend` : "Results ready email"}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="results-ready-dialog">
          <DialogHeader><DialogTitle className="font-serif text-2xl">Tell {row.patient_name || "the patient"} their results are ready</DialogTitle></DialogHeader>
          <p className="text-sm text-ink-muted">They&apos;ll get a short email inviting them to book a follow-up, in person or by telephone.</p>
          {tests.length > 0 && (
            <label className="flex items-start gap-2 text-sm mt-2">
              <input type="checkbox" checked={nameTests} onChange={(e) => setNameTests(e.target.checked)} data-testid="results-ready-name-tests" className="mt-1 accent-[#8C6643]" />
              <span>Name the test in the email ({tests.join(", ")})<span className="block text-xs text-ink-muted">Leave unticked to keep health details out of email.</span></span>
            </label>
          )}
          <div className="flex gap-3 mt-4">
            <button type="button" className="btn-primary" disabled={busy} onClick={send} data-testid="results-ready-send">{busy ? "Sending…" : "Send email"}</button>
            <button type="button" className="btn-secondary" onClick={() => setOpen(false)} data-testid="results-ready-cancel">Cancel</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
